document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('deferred-media').forEach((deferredMedia) => {
    deferredMedia.addEventListener('load', () => {
      const video = deferredMedia.querySelector('video');
      if (!video) return;

      video.play().catch(() => {});
    });
  });
});
